import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tag } from 'antd';
import startCase from 'lodash/startCase';

const StatusToColor = {
  draft: 'magenta',
  published: 'blue',
  archived: 'purple',
};

const StyledTag = styled(Tag)`
  text-transform: capitalize;
`;

/**
 * @deprecated use Tag component from antd directly instead
 *
 * This component doest not offer support for translations
 * and also limit the number of Status on the list. Since each area can have
 * different statuses list, we recommend to use Tag component from antd directly.
 *
 */
const AntdTag = ({ status }) => (
  <StyledTag color={StatusToColor[status]}>{startCase(status)}</StyledTag>
);

AntdTag.prototypes = {
  status: PropTypes.string.isRequired,
};

export { AntdTag };
